module.exports = __webpack_public_path__ + "assets/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 84
// module chunks = 7